
import React from "react";
import { NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent } from "@/components/ui/navigation-menu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TabContentWithImage } from "./TabContent";
import { ContactForm } from "./ContactForm";

interface SupportMenuProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  allImagesLoaded: boolean;
  onContactSuccess: () => void;
}

export const SupportMenu: React.FC<SupportMenuProps> = ({
  activeTab,
  onTabChange,
  allImagesLoaded,
  onContactSuccess
}) => {
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className="bg-transparent hover:bg-gray-200 text-primary text-sm font-medium">Support</NavigationMenuTrigger>
      <NavigationMenuContent className="w-[95vw] min-w-[95vw] max-w-[1000px] h-[500px] bg-white rounded-md shadow-lg p-4 border border-gray-200">
        <Tabs value={activeTab} onValueChange={onTabChange} orientation="vertical" className="flex">
          <TabsList className="flex flex-col w-1/4 h-[450px] bg-gray-50 rounded-l-md space-y-1 p-2 border-r border-primary portrait:w-1/4 portrait:min-w-[120px]">
            <TabsTrigger value="helpdesk" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Help Desk
            </TabsTrigger>
            <TabsTrigger value="contact" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Contact Us
            </TabsTrigger>
            <TabsTrigger value="faq" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              FAQ
            </TabsTrigger>
          </TabsList>
          <TabsContent value="helpdesk" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1560264280-88b68371db39?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Help Desk"
              title="Help Desk"
              description="24/7 technical support and troubleshooting assistance for all our AI solutions and services."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="contact" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <ContactForm onSuccess={onContactSuccess} />
          </TabsContent>
          <TabsContent value="faq" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <div className="flex flex-col items-center">
              <h3 className="text-lg font-medium mb-2 text-primary-dark">Frequently Asked Questions</h3>
              <div className="w-full space-y-4">
                <div className="border border-gray-200 rounded-md p-3">
                  <h4 className="font-medium text-primary-dark">How quickly can I implement your AI solutions?</h4>
                  <p className="text-sm mt-2">Most of our solutions can be implemented within 8-12 weeks, depending on the complexity of your organization and existing systems.</p>
                </div>
                <div className="border border-gray-200 rounded-md p-3">
                  <h4 className="font-medium text-primary-dark">Do you offer customization services?</h4>
                  <p className="text-sm mt-2">Our AI solutions are designed to be highly flexible through configuration to meet your specific business requirements with minimal customization.</p>
                </div>
                <div className="border border-gray-200 rounded-md p-3">
                  <h4 className="font-medium text-primary-dark">What kind of ROI can I expect?</h4>
                  <p className="text-sm mt-2">Our clients typically see 15-30% improvement in operational efficiency and 20-40% reduction in process time within a short time.</p>
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};
